/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Embed_Export_Output_Track_IndexInputs */

const en_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.index}`)
};

const fr_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piste ${i?.index}`)
};

const de_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Track ${i?.index}`)
};

const it_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Traccia ${i?.index}`)
};

const ru_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Трек ${i?.index}`)
};

const es_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pista ${i?.index}`)
};

const zh_cn2_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`追踪${i?.index}`)
};

const ja_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`トラック ${i?.index}`)
};

const hi_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ट्रैक ${i?.index}`)
};

const pt_pt2_audio_embed_export_output_track_index = /** @type {(inputs: Audio_Embed_Export_Output_Track_IndexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Faixa ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Track {index}" |
*
* @param {Audio_Embed_Export_Output_Track_IndexInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_track_index = /** @type {((inputs: Audio_Embed_Export_Output_Track_IndexInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Track_IndexInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_output_track_index(inputs)
	if (locale === "de") return de_audio_embed_export_output_track_index(inputs)
	if (locale === "it") return it_audio_embed_export_output_track_index(inputs)
	if (locale === "ru") return ru_audio_embed_export_output_track_index(inputs)
	if (locale === "es") return es_audio_embed_export_output_track_index(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_output_track_index(inputs)
	if (locale === "ja") return ja_audio_embed_export_output_track_index(inputs)
	if (locale === "hi") return hi_audio_embed_export_output_track_index(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_output_track_index(inputs)
	return en_audio_embed_export_output_track_index(inputs)
});